'use client';

import * as React from 'react';
import * as AccordionPrimitive from '@radix-ui/react-accordion';

import { cn } from '@streetferret/utils';
import { ChevronDownIcon } from '@radix-ui/react-icons';

const CardAccordion = AccordionPrimitive.Root;

const CardAccordionItem = React.forwardRef<
  React.ElementRef<typeof AccordionPrimitive.Item>,
  React.ComponentPropsWithoutRef<typeof AccordionPrimitive.Item>
>(({ className, ...props }, ref) => (
  <AccordionPrimitive.Item
    ref={ref}
    className={cn('border-b mb-4', className)}
    {...props}
  />
));
CardAccordionItem.displayName = 'CardAccordionItem';

const CardAccordionTrigger = React.forwardRef<
  React.ElementRef<typeof AccordionPrimitive.Trigger>,
  React.ComponentPropsWithoutRef<typeof AccordionPrimitive.Trigger>
>(({ className, children, ...props }, ref) => (
  <AccordionPrimitive.Header className="flex">
    <AccordionPrimitive.Trigger
      ref={ref}
      className={cn(
        'flex flex-1 items-center justify-between py-4 font-medium transition-all hover:bg-muted hover:text-muted-foreground [&[data-state=open]>svg]:rotate-180 px-3 [&[data-state=open]]:border-x [&[data-state=open]]:border-t rounded-t-md',
        className,
      )}
      {...props}>
      {children}
      <ChevronDownIcon className="h-4 w-4 shrink-0 transition-transform duration-200" />
    </AccordionPrimitive.Trigger>
  </AccordionPrimitive.Header>
));
CardAccordionTrigger.displayName = AccordionPrimitive.Trigger.displayName;

const CardAccordionContent = React.forwardRef<
  React.ElementRef<typeof AccordionPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof AccordionPrimitive.Content>
>(({ className, children, ...props }, ref) => (
  <AccordionPrimitive.Content
    ref={ref}
    className="overflow-hidden text-sm transition-all data-[state=closed]:animate-accordion-up data-[state=open]:animate-accordion-down"
    {...props}>
    <div className={cn('pb-4 pt-0', className)}>{children}</div>
  </AccordionPrimitive.Content>
));

CardAccordionContent.displayName = AccordionPrimitive.Content.displayName;

export {
  CardAccordion,
  CardAccordionItem,
  CardAccordionTrigger,
  CardAccordionContent,
};
